<div class="custom-container">
  <div class="py-70">
    <app-section-heading [sectionHeading]="explore.sectionHeading" />

    <div class="explore-grid-template mt-45">
      <div
        class="card-container w-100 min-h-205"
        *ngFor="let exploreCard of explore.exploreCards"
      >
        <p class="section-sub-title">{{ exploreCard.title }}</p>
        <p class="section-text max-w-245 mt-10">
          {{ exploreCard.text }}
        </p>

        <div class="explore-number">{{ exploreCard.id }}</div>
      </div>
    </div>
  </div>
</div>
